export default __webpack_public_path__ + "static/media/vim-substitution.725c12f4.png";